import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ChevronUp } from 'lucide-react';

const ScrollButton = styled.button`
  position: fixed;
  bottom: 100px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #87ceeb 0%, #4682b4 100%);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  box-shadow: 
    0 8px 25px rgba(135, 206, 235, 0.3),
    0 4px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${props => props.show ? 1 : 0};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  transform: ${props => props.show ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.8)'};
  
  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 
      0 12px 35px rgba(135, 206, 235, 0.4),
      0 6px 15px rgba(0, 0, 0, 0.15);
    background: linear-gradient(135deg, #4682b4 0%, #87ceeb 100%);
  }
  
  &:active {
    transform: translateY(-1px) scale(0.98);
  }
  
  i {
    font-size: 28px;
    font-weight: bold;
  }
  
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    bottom: 85px;
    right: 15px;
    
    i {
      font-size: 24px;
    }
  }
`;

const ScrollToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setShow(window.scrollY > 400);
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <ScrollButton show={show} onClick={scrollToTop} aria-label="Scroll to top">
      <ChevronUp size={28} />
    </ScrollButton>
  );
};

export default ScrollToTop;